// eslint-disable-next-line import/prefer-default-export
export const getBaseUrl = urlWithApiVersion => typeof urlWithApiVersion === 'string' && urlWithApiVersion.match(/^https.*\.com/)[0];
